import React, { useContext, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ModelsTable from '../../components/inventory/models-table';
import BrandsTable from '../../components/inventory/brands-table';
import TextField from '@mui/material/TextField/TextField';
import PageLayout from '../../components/common/page-layout';
import { ModalContext } from '../../contexts/modal';
import { Box, FormControl, Input, InputLabel, MenuItem, Select } from '@mui/material';
import ColorsTable from '../../components/inventory/colors-table';
import {
  useCreateBrand,
  useCreateColor,
  useCreateModel,
  useGetBrands,
} from '../../api/hooks/inventory';
import { useQueryClient } from 'react-query';
import { BRANDS_KEY, COLOR_KEY, MODELS_KEY } from '../../api/hooks/cache-keys';

export default function Models() {
  const { setOpen, setContent, setTitle } = useContext(ModalContext);

  function openModelModal() {
    const cont = <CreateModelModal />;
    setContent(cont);
    setTitle('ساخت مدل جدید');
    setOpen(true);
  }

  function openBrandModal() {
    const cont = <CreateBrandModal />;
    setContent(cont);
    setTitle('ساخت برند جدید');
    setOpen(true);
  }

  function openColorModal() {
    const cont = <CreateColorModal />;
    setContent(cont);
    setTitle('ساخت رنگ جدید');
    setOpen(true);
  }

  return (
    <PageLayout pageTitle="جزئیات دستگاه‌ها">
      <Grid container spacing={3}>
        <Grid item xs={10} md={6}>
          <Button variant="contained" color="primary" sx={{ mb: 3 }} onClick={openModelModal}>
            افزودن مدل
          </Button>
          <ModelsTable />
        </Grid>
        <Grid item xs={10} md={2}>
          <Button variant="contained" color="primary" sx={{ mb: 3 }} onClick={openBrandModal}>
            افزودن برند
          </Button>
          <BrandsTable />
        </Grid>
        <Grid item xs={10} md={4}>
          <Button variant="contained" color="primary" sx={{ mb: 3 }} onClick={openColorModal}>
            افزودن رنگ
          </Button>
          <ColorsTable />
        </Grid>
      </Grid>
    </PageLayout>
  );
}

function CreateModelModal() {
  const nameRef = useRef();
  const ramRef = useRef();
  const storageRef = useRef();
  const queryClient = useQueryClient();

  const [brand, setBrand] = useState('');
  const { data: brands } = useGetBrands();
  const createModel = useCreateModel();
  const { setOpen } = useContext(ModalContext);

  async function onClick() {
    await createModel.mutateAsync({
      name: nameRef.current.value,
      ram: ramRef.current.value,
      memory: storageRef.current.value,
      brandId: brand,
    });
    setOpen(false);
    await queryClient.invalidateQueries(MODELS_KEY());
  }

  return (
    <form autoComplete={false}>
      <Box sx={{ my: 2 }}>
        <TextField label="نام مدل" variant="filled" size="small" fullWidth inputRef={nameRef} />
      </Box>
      <FormControl variant="filled" size="small" fullWidth>
        <InputLabel>نام برند</InputLabel>
        <Select
          fullWidth
          label="برند"
          placeholder="برند"
          onChange={(e) => setBrand(e.target.value)}
        >
          {brands?.map((b) => (
            <MenuItem value={b.id} key={b.id}>
              {b.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box sx={{ my: 2 }}>
        <TextField
          label="رم"
          variant="filled"
          size="small"
          type="numeric"
          fullWidth
          inputRef={ramRef}
        />
      </Box>
      <Box sx={{ my: 2 }}>
        <TextField
          label="حافظه داخلی"
          variant="filled"
          size="small"
          type="numeric"
          fullWidth
          inputRef={storageRef}
        />
      </Box>

      <Button variant="contained" color="primary" sx={{ mb: 4 }} fullWidth onClick={onClick}>
        ایجاد
      </Button>
    </form>
  );
}

function CreateBrandModal() {
  const nameRef = useRef();
  const queryClient = useQueryClient();

  const createBrand = useCreateBrand();
  const { setOpen } = useContext(ModalContext);
  const [error, setError] = useState(false);

  const onClick = async () => {
    try {
      await createBrand.mutateAsync({ name: nameRef.current.value });
      setOpen(false);
      await queryClient.invalidateQueries(BRANDS_KEY());
    } catch {
      setError(true);
    }
  };

  return (
    <form autoComplete="">
      <Box sx={{ my: 2 }}>
        <TextField
          label="نام برند"
          variant="filled"
          size="small"
          fullWidth
          inputRef={nameRef}
          error={error}
        />
      </Box>
      <Button variant="contained" color="primary" sx={{ mb: 4 }} fullWidth onClick={onClick}>
        ایجاد
      </Button>
    </form>
  );
}

function CreateColorModal() {
  const nameRef = useRef();
  const codeRef = useRef();

  const createColor = useCreateColor();
  const { setOpen } = useContext(ModalContext);
  const [error, setError] = useState(false);
  const queryClient = useQueryClient();

  const onClick = async () => {
    try {
      await createColor.mutateAsync({ name: nameRef.current.value, rgb: codeRef.current.value });
      setOpen(false);
      await queryClient.invalidateQueries(COLOR_KEY());
    } catch {
      setError(true);
    }
  };

  return (
    <form autoComplete="">
      <Box sx={{ my: 2 }}>
        <TextField
          label="نام رنگ"
          variant="filled"
          size="small"
          fullWidth
          inputRef={nameRef}
          error={error}
        />
        <Input type="color" name="رنگ" fullWidth inputRef={codeRef} />
      </Box>
      <Button variant="contained" color="primary" sx={{ mb: 4 }} fullWidth onClick={onClick}>
        ایجاد
      </Button>
    </form>
  );
}
